module.exports = __webpack_public_path__ + "img/cloud-computing.c35ac355.png";